import React from 'react';

import ReduxConnect from 'Demora/redux-connect';

import ShowAward from './ShowAward';

import { Popover, PopoverBody } from 'reactstrap';

import { Link } from 'react-router-dom';

import classnames from 'classnames';

import follower from '../../../images/follower.svg';

import following from '../../../images/following.svg';

import referrer from '../../../images/referral-icon.svg';

class ProfileNextToName extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			v: (Math.random() + '').split('.')[1],
			popoverExpert: false,
			popoverFollowing: false,
			popoverFollower: false,
			popoverReferrer: false,
		};
	}

	toggle = (t) => {
		const a = {};
		a[t] = !this.state[t];
		this.setState(a);
	};

	render() {
		const props = this.props;

		const state = this.state;

		const user = props.users[props.obj];

		const iconHeight = props.iconHeight ?? 14;

		const st = {
			height: (iconHeight * 26) / 18 + 'px',
			width: (iconHeight * 20) / 18 + 'px',
		};

		return (
			<span style={{ verticalAlign: 'top' }}>
				{user.expert && (
					<div
						className={classnames('ml-1 d-inline-block')}
						id={'PopoverExpert' + state.v}
						onMouseEnter={() => this.toggle('popoverExpert')}
						onMouseLeave={() => this.toggle('popoverExpert')}
						style={st}
					>
						<i
							className='fas fa-star'
							style={{
								color: '#ffd300',
								fontSize: iconHeight + 'px',
								verticalAlign: 'top',
							}}
						/>
						<Popover
							placement='top'
							isOpen={state.popoverExpert}
							target={'PopoverExpert' + state.v}
							toggle={() => {}}
						>
							<PopoverBody>
								{user.first_name} is a CashJuice expert. You can become a
								CashJuice expert by following the simple tasks on the{' '}
								<Link to={'/home/dashboard'}>dashboard page.</Link>
							</PopoverBody>
						</Popover>
					</div>
				)}
				<ShowAward
					obj={this.props.obj}
					iconHeight={iconHeight}
					iconWidth={iconHeight}
				/>

				{user.r && user.r.fers && (
					<div
						className={classnames('ml-1 d-inline-block')}
						id={'popoverFollower' + state.v}
						onMouseEnter={() => this.toggle('popoverFollower')}
						onMouseLeave={() => this.toggle('popoverFollower')}
						style={st}
					>
						<Popover
							placement='top'
							isOpen={state.popoverFollower}
							target={'popoverFollower' + state.v}
							toggle={() => {}}
						>
							<PopoverBody>{user.first_name} is following you</PopoverBody>
						</Popover>

						<img
							src={follower}
							style={{ height: iconHeight + 'px', verticalAlign: 'top' }}
						/>
					</div>
				)}

				{user.r && user.r.fing && (
					<div
						className={classnames('ml-1 d-inline-block')}
						id={'popoverFollowing' + state.v}
						onMouseEnter={() => this.toggle('popoverFollowing')}
						onMouseLeave={() => this.toggle('popoverFollowing')}
						style={st}
					>
						<Popover
							placement='top'
							isOpen={state.popoverFollowing}
							target={'popoverFollowing' + state.v}
							toggle={() => {}}
						>
							<PopoverBody>You are following {user.first_name}</PopoverBody>
						</Popover>

						<img
							src={following}
							style={{ height: iconHeight + 'px', verticalAlign: 'top' }}
						/>
					</div>
				)}

				{user.r && user.r.ref && (
					<div
						className={classnames('ml-1 d-inline-block')}
						id={'popoverReferrer' + state.v}
						onMouseEnter={() => this.toggle('popoverReferrer')}
						onMouseLeave={() => this.toggle('popoverReferrer')}
						style={{
							...st,
							width: (iconHeight * 27.5) / 18 + 'px',
						}}
					>
						<Popover
							placement='top'
							isOpen={state.popoverReferrer}
							target={'popoverReferrer' + state.v}
							toggle={() => {}}
						>
							<PopoverBody>You referred {user.first_name}</PopoverBody>
						</Popover>

						<img
							src={referrer}
							style={{
								height: iconHeight + 'px',
								width: (iconHeight * 27.5) / 18 + 'px',
								verticalAlign: 'top',
							}}
						/>
					</div>
				)}
			</span>
		);
	}
}

export default ReduxConnect(ProfileNextToName, {
	users: 'users',
});
